import type { FlowState } from '@de/providers';
import type { Option, Step } from '@de/types';

type StepDataResult = {
  option: Option | Option[] | undefined;
  values: string[];
};

/**
 * Gets the selected option(s) and string values for a step by its stepName.
 */
export const getStepData = (
  stepName: string,
  steps: Step[],
  flowState: FlowState,
): StepDataResult => {
  const step = steps.find((s) => s.stepName === stepName);
  if (!step?.id) return { option: undefined, values: [] };

  const stepState = flowState[step.id];
  if (!stepState?.option) return { option: undefined, values: [] };

  const options = Array.isArray(stepState.option)
    ? stepState.option
    : [stepState.option];

  const values = options
    .map((opt: Option) => opt.value)
    .filter((val): val is string => typeof val === 'string');

  return { option: stepState.option, values };
};
